<template>
  <dx-data-grid
    ref="dataGridRef"
    :allow-column-reordering="true"
    :column-chooser="{ enabled: true, mode: 'select' }"
    :column-min-width="150"
    :columns="columns"
    :data-source="dataSource"
    :filter-panel="{ visible: true }"
    :filter-row="{ visible: true }"
    :header-filter="{ visible: true }"
    :height="50"
    :hover-state-enabled="true"
    :remote-operations="true"
    :row-alternation-enabled="true"
    :show-borders="true"
    :show-column-lines="true"
    :width="'100%'"
    :word-wrap-enabled="true"
    style="flex-grow: 1"
    @toolbar-preparing="onToolbarPreparing($event)"
    @content-ready="onContentReady($event)"
  >
    <dx-paging :enabled="true" :page-size="30" />
    <dx-load-panel :enabled="true" />
    <dx-scrolling mode="virtual" />
    <dx-sorting mode="single" />
    <dx-export :allow-export-selected-data="true" :enabled="true" :formats="['pdf', 'excel']" />

  </dx-data-grid>

  <footer-grid :totalCount="totalCount" class="px-2"></footer-grid>

  <mped-fact-file-uploader-component v-if="isEditable" ref="costFactUploader" area="calculation" />
</template>

<script>
export default {
  name: 'mped-calculation-upload-view',
};
</script>

<script setup>
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

import {
  DxDataGrid,
  DxScrolling,
  DxLoadPanel,
  DxSorting,
  DxExport,
  DxPaging,
} from 'devextreme-vue/data-grid';

import FooterGrid from '@/components/grid-card-component/footer-grid.vue';
import MpedFactFileUploaderComponent
  from '@/views/mped/components/mped-calculation-upload/mped-fact-file-uploader-component.vue';
import { getAiToolbar } from '@/components/utils/ai-toolbar-generator';
import { getAiDataSource } from '@/components/utils/ai-data-source-generator';
import { getUploadedHistorySapData } from '@/views/mped/services/mped-calculation-api-service';
import { columnsUploadHistorySap } from '@/views/mped/services/mped-calculation-service';
import { initState, setLocalUserdata, hasEditablePermissionByUIRoute } from '@/service/local-userdata-service';
import { svgAiLibrary } from '@/service/svg-ai-library';

const
  totalCount = ref(0),
  costFactUploader = ref(),
  columns = columnsUploadHistorySap,
  dataGridRef = ref(),
  router = useRouter(),
  isEditable = hasEditablePermissionByUIRoute(router);

const dataSource = getAiDataSource(
  {
    dataFn: getUploadedHistorySapData,
    key: 'kod_sp_zatr_load_log',
    remoteOperation: true,
    validationFn: () => {
      return true;
    },
    onLoadedFn: (data) => {
      totalCount.value = data.totalCount;
    },
  },
);

onMounted(async () => {
  initState(router, dataGridRef);
});

const onToolbarPreparing = (e) => {
  getAiToolbar(e, {
    customs: [{
      visible: true,
      widget: 'dxButton',
      location: 'after',
      name: 'uploadFile',
      after: 'refresh',
      cssClass: 'toolbar-item-custom-style',
      options: {
        disabled: !isEditable,
        icon: svgAiLibrary['ai-upload-file-base'],
        hint: 'Загрузить файл',
        onClick: () => {
          costFactUploader.value.Open();
        },
      },
    }],
    refresh: {
      event: reloadData,
    },
  });
};

const reloadData = () => {
  dataSource.reload();
};

const onContentReady = (e) => {
  setLocalUserdata(router, dataGridRef);
}

</script>

<style scoped>

</style>
